import React from 'react';
import { CheckCircle2, Globe2, HelpCircle, Landmark, Sparkles } from 'lucide-react';
import { Section } from './Section';

export const buildFAQSchema = (faqs = []) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((item) => ({
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.answer
    }
  }))
});

export const GeoSeoSections = ({ slug, regionLabel, successCases, sectors, faqs, localSignals }) => {
  return (
    <>
      <Section>
        <div className="max-w-6xl mx-auto grid gap-6 lg:grid-cols-[1.05fr_0.95fr]">
          <div className="glass-card tracing-panel p-8" data-testid={`${slug}-success-cases-card`}>
            <div className="flex items-center gap-3 text-primary">
              <Sparkles className="w-5 h-5" />
              <p className="text-xs font-semibold uppercase tracking-[0.2em]">Casos de éxito en {regionLabel}</p>
            </div>
            <div className="mt-6 space-y-4">
              {successCases.map((item, index) => (
                <article key={`${item.title}-${index}`} className="rounded-[24px] border border-border-subtle bg-background/50 p-5" data-testid={`${slug}-success-case-${index + 1}`}>
                  <p className="text-sm font-semibold text-text-heading">{item.title}</p>
                  <p className="mt-3 text-sm text-text-body">{item.copy}</p>
                  <p className="mt-4 text-xs uppercase tracking-[0.18em] text-primary">Resultado esperado · {item.outcome}</p>
                </article>
              ))}
            </div>
          </div>

          <div className="glass-card tracing-panel p-8" data-testid={`${slug}-local-signals-card`}>
            <div className="flex items-center gap-3 text-primary">
              <Landmark className="w-5 h-5" />
              <p className="text-xs font-semibold uppercase tracking-[0.2em]">Contexto local</p>
            </div>
            <div className="mt-6 space-y-4">
              {localSignals.map((item, index) => (
                <div key={`${item}-${index}`} className="rounded-[20px] border border-border-subtle bg-card/40 p-4 text-sm text-text-body" data-testid={`${slug}-local-signal-${index + 1}`}>
                  <CheckCircle2 className="mr-2 inline h-4 w-4 text-primary" />
                  {item}
                </div>
              ))}
            </div>
          </div>
        </div>
      </Section>

      <Section>
        <div className="max-w-6xl mx-auto">
          <div className="mb-6 max-w-3xl">
            <p className="editorial-kicker">Sectores con más encaje</p>
            <h2 className="mt-5">Dónde encaja mejor esta propuesta en {regionLabel}</h2>
            <p className="mt-4 text-base text-text-body">No ofrecemos una IA genérica. Diseñamos sistemas aplicados a sectores donde seguimiento, documentación, coordinación y velocidad comercial marcan diferencia.</p>
          </div>
          <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-4">
            {sectors.map((item, index) => (
              <article key={`${item.title}-${index}`} className="glass-card tracing-panel p-6" data-testid={`${slug}-sector-card-${index + 1}`}>
                <div className="flex items-center gap-3 text-primary">
                  <Globe2 className="w-5 h-5" />
                  <p className="text-xs uppercase tracking-[0.18em]">{item.badge}</p>
                </div>
                <p className="mt-4 text-lg font-semibold text-text-heading">{item.title}</p>
                <p className="mt-3 text-sm text-text-body">{item.copy}</p>
              </article>
            ))}
          </div>
        </div>
      </Section>

      <Section>
        <div className="max-w-6xl mx-auto glass-card tracing-panel p-8 md:p-10" data-testid={`${slug}-faq-section`}>
          <div className="max-w-3xl">
            <div className="flex items-center gap-3 text-primary">
              <HelpCircle className="w-5 h-5" />
              <p className="text-xs font-semibold uppercase tracking-[0.2em]">FAQs locales</p>
            </div>
            <h2 className="mt-5">Preguntas frecuentes sobre IA aplicada en {regionLabel}</h2>
          </div>
          <div className="mt-8 grid gap-4 md:grid-cols-2">
            {faqs.map((item, index) => (
              <article key={`${item.question}-${index}`} className="rounded-[24px] border border-border-subtle bg-background/45 p-6" data-testid={`${slug}-faq-item-${index + 1}`}>
                <p className="text-base font-semibold text-text-heading">{item.question}</p>
                <p className="mt-3 text-sm text-text-body">{item.answer}</p>
              </article>
            ))}
          </div>
        </div>
      </Section>
    </>
  );
};